import { Box, Container, Image, SimpleGrid, Text, Wrap, WrapItem, useColorMode } from "@chakra-ui/react";
import { motion } from "framer-motion";
import resume from "../vatars/Rohit-Prajapat-Resume.pdf";

const aboutTextStyle = {
  fontSize: ["12px", "14px", "16px", "18px"],
  lineHeight: ["20px", "24px", "28px", "32px"],
  fontFamily: "Roboto, sans-serif",
};

function AboutP() {
  const { colorMode } = useColorMode();

  
  const textColor = colorMode === "dark" ? "black" : "black ";

  return (
    <>
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "100%" }}
        exit={{ x: window.innerWidth, transition: { duration: 0.4 } }}
      >
        <Box width="90%" maxW="1200px" margin="auto" mt={["50px", "100px"]} boxShadow="lg" borderRadius="xl" bg="white">
          <Box p={["4", "6"]}>
            <Box display="flex" alignItems="center" mb={["2", "4"]}>
              <Text fontSize={["20px", "24px", "30px"]} fontWeight="bold">
                About Me
              </Text>
            </Box>
            <SimpleGrid columns={["1", "1", "1", "2"]} spacing={["4", "6"]}>
              <Box>
                <Image
                  src="https://cdn.dribbble.com/users/926537/screenshots/4502924/python-2.gif"
                  borderRadius="xl"
                  boxShadow="lg"
                  w="100%"
                  h="auto"
                />
              </Box>
              <Box>
                <Container maxWidth={"-moz-fit-content"}>
                  <Text {...aboutTextStyle} textAlign="justify" color={textColor}>
                    I am a result-oriented full-stack web developer, passionate about developing user-friendly web
                    applications using MERN Stack.
                    <br />
                    <br />
                    I enjoy developing websites and have a keen interest in solving problems and coming up with effective
                    solutions.
                    <br />
                    <br />
                    Eager to be a part of a team that gives me the ability to learn and grow.
                  </Text>
                </Container>
              </Box>
            </SimpleGrid>
            <Box mt={["4", "6"]}>
              <Wrap justify="center" spacing={["2", "4"]}>
                <WrapItem>
                  <Box w={["40px", "60px"]} h={["40px", "60px"]} borderRadius="full" bg="teal.500" boxShadow="lg" />
                </WrapItem>
                <WrapItem>
                  <Box w={["40px", "60px"]} h={["40px", "60px"]} borderRadius="full" bg="purple.500" boxShadow="lg" />
                </WrapItem>
                <WrapItem>
                  <Box w={["40px", "60px"]} h={["40px", "60px"]} borderRadius="full" bg="pink.500" boxShadow="lg" />
                </WrapItem>
                <WrapItem>
                  <Box w={["40px", "60px"]} h={["40px", "60px"]} borderRadius="full" bg="cyan.500" boxShadow="lg" />
                </WrapItem>
                <WrapItem>
                  <Box w={["40px", "60px"]} h={["40px", "60px"]} borderRadius="full" bg="orange.500" boxShadow="lg" />
                </WrapItem>
              </Wrap>
            </Box>
          </Box>
        </Box>
      </motion.div>
    </>
  );
}

export default AboutP;
